<template>
    <div>
        <div>
            <a-button class="top_btn" type="primary" @click="()=>{visible = true; title='添加分类' ;this.editId=''; }" >
                添加分类
            </a-button>
            <a-button class="top_btn" type="primary" @click="listOrder()"  >
              排序
            </a-button>
<!--            <a-button class="top_btn" type="primary"   @click="editLanguage('open','1')">-->
<!--                展开-->
<!--            </a-button>-->
<!--            <a-button class="top_btn" type="primary"   @click="editLanguage('open','0')">-->
<!--                收起-->
<!--            </a-button>-->
<!--            <a-button class="top_btn" type="primary" :disabled="!hasSelected" :loading="loading"-->
<!--                      @click="editLanguage('status','1')">-->
<!--                显示-->
<!--            </a-button>-->
<!--            <a-button class="top_btn" type="primary" :disabled="!hasSelected" :loading="loading"-->
<!--                      @click="editLanguage('status','0')">-->
<!--                隐藏-->
<!--            </a-button>-->
            <a-popconfirm
                    title="此操作将永久删除, 是否继续?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="editLanguage('','5')"
                    @cancel="()=>{}"
                    :disabled="!hasSelected"
            >
                <a-button   type="primary" :disabled="!hasSelected" :loading="loading" >
                    删除
                </a-button>
            </a-popconfirm>
            <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template>
      </span>
        </div>

        <div>
            <a-spin :spinning="loading">
            <div class="table">
                <div class="th flex" >
                    <div style="width:5%"> <a-checkbox @change="onCheckAllChange" v-model="checAll" >  </a-checkbox>  </div>
                  <div style="width:5%">排序</div>
                    <div style="width:50%">分类名称</div>
                    <div style="width:20%">状态</div>
                    <div style="width:20%">操作</div>
                </div>
                <div class="trBigbox">
                    <div class="trbox " v-for="(item ,index) in data" :row-key="item.id">
                        <div class="tr flex">
                            <div class="td" style="width:5%"> <a-checkbox @change="(checkedValue)=>{ onChanges(checkedValue,item.id) }  " :options="item.id"  v-model="item.check">  </a-checkbox> </div>
                          <div class="td" style="width:5%">   <a-input   v-model="item.list_order" class="inputs" size="small"/> </div>

                          <div class="td" style="width:50%">
                            <div @click="changopen(item,index)" >
                           <div style="width: 18px; "><div role="button" tabindex="0" aria-label="关闭行" class="ant-table-row-expand-icon ant-table-row-expanded" v-if="item.children.length&&item.show==1"></div></div>
                           <div style="width: 18px; "><div role="button" tabindex="0" aria-label="展开行" class="ant-table-row-expand-icon ant-table-row-collapsed" v-if="item.children.length&&item.show!=1"></div></div>
                            </div>
                           <p style="padding-left: 18px">{{item.name}}</p>
                        </div>
                        <div class="td" style="width:20%"> <a-switch   @click="()=>{onChange(item,item.id);item.status==1? item.status=2:item.status=1}" :checked="item.status==1?true:false"  /></div>
                        <div class="td" style="width:20%">
                            <a @click="(record)=>{visible = true;; title='修改分类'; editId=item.id ;childLeng=item.children.length }" >编辑  </a>
                            <a-divider  type="vertical"/>
                            <a-popconfirm title="此操作将永久删除, 是否继续?"  ok-text="确定" cancel-text="取消" @confirm="confirm(item.id)" @cancel="()=>{}" >
                                <a >删除</a>
                            </a-popconfirm></div>
                            <a-divider  type="vertical"/>
                        </div>
                        <div class="children childrens" v-show="item.children&&item.children.length>0&&item.show&&item.show==1">
                            <div class="tr flex" v-for="itemc in item.children">
                            <div class="td" style="width:5%"> <a-checkbox @change="(checkedValue)=>{ onChanges(checkedValue,itemc.id )  } " :options="itemc.id"  v-model="itemc.check">  </a-checkbox> </div>
                            <div class="td" style="width:5%"> <a-input   v-model="itemc.list_order" class="inputs" size="small"/> </div>
                            <div class="td" style="width:50% ;padding-left:55px">{{itemc.name}}</div>
                            <div class="td" style="width:20%"> <a-switch   @click="()=>{onChange(itemc,item.id);itemc.status==1? itemc.status=2:itemc.status=1}" :checked="itemc.status==1?true:false" /></div>
                            <div class="td" style="width:20%">

                                <a @click="(record)=>{visible = true;; title='修改分类'; editId=itemc.id ;}" >编辑 <a-divider type="vertical"/></a>

                                <a-popconfirm title="此操作将永久删除, 是否继续?"  ok-text="确定" cancel-text="取消" @confirm="confirm(itemc.id)" @cancel="()=>{}" >
                                    <a >删除 </a>
                                </a-popconfirm></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </a-spin>
        </div>

        <NewForm :visible="visible" :title="title" :editId="editId" :childLeng="childLeng"  @changVisible=" () => { this.visible = false;this.editId='';this.childLeng=null; this.getList()}  "/>

    </div>
</template>

<script>
    import API from "./api";
    import NewForm from "./components/newForm"
    import draggable from 'vuedraggable'
    import Sortable from 'sortablejs'
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    export default {
        name: "index",
        data() {
            return {
                indeterminate: false,
                checAll: false,
                visibleImg: false,
                tableImg: "",
                seach: {
                    name: "",
                },
                data: [],
                changData:[],
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                visible: false,
                title: "",
                editId: null,
                childLeng:null
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/ksh/ControlCategory"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
            this.$nextTick(() => {
                setTimeout(() => {
                    this.drag()
                },500)
            })
        },
        components: {NewForm,draggable},
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            changopen(item,i){
               if(this.data[i].show==undefined) {
                   this.data[i].show=1
                   this.drag()
               }else{
                   this.data[i].show==1?this.data[i].show=2:this.data[i].show=1
                   this.drag()
               }
            },
            onChanges(checkedValue,id,pid="") {
                let data=this.data
                let check=checkedValue.target.checked
                for (let i = 0; i < data.length; i++) {
                  if(data[i].id==id){
                      data[i].children .map((item,index)=>{
                          item.check=check
                      })
                  }
                }
               if(pid!="") {
                   data.map((item,index)=>{
                       if(item.id==pid){
                           let len=0
                           item.children.map((items,index)=>{
                             if(items.check==true){len++}
                           })
                           item.children.length==len ?item.check=true:item.check=false
                       }
                   })
               }
               this.selectedRowKeys=[]
               this.getCheck(this.data)
            },
            getCheck(data){
                    for (let i = 0; i < data.length; i++) {
                       if(data[i].check==true) this.selectedRowKeys=[...this.selectedRowKeys,data[i].id]
                        if (data[i].children && data[i].children.length > 0) {
                            this.getCheck(data[i].children)
                        }
                        if(this.selectedRowKeys.length==0){
                            this.checAll=false
                        }else{
                            this.checAll=true
                        }
                    }
            },
            onCheckAllChange(checkedValue) {
                let data=this.data
                let check=checkedValue.target.checked
                const checkList = (data)=> {
                    for (let i = 0; i < data.length; i++) {
                        data[i].check=check
                        if (data[i].children && data[i].children.length > 0) {
                            checkList(data[i].children)
                        }
                    }
                }
                checkList(data)
                this.selectedRowKeys=[]
                this.getCheck(this.data)

            },
            drag () {
                // 首先获取需要拖拽的dom节点
                const _this = this
                const el1 = document.querySelectorAll('.children')
              for(let i=0;i<el1.length;i++){
                  Sortable.create(el1[i], {
                      handle:".dragicon",
                      disabled: false, // 是否开启拖拽
                      ghostClass: 'sortable-ghost', //拖拽样式
                      animation: 150, // 拖拽延时，效果更好看
                      group: { // 是否开启跨表拖拽
                          pull: false,
                          put: false
                      },
                      onEnd: ({ newIndex, oldIndex }) => { // 这里主要进行数据的处理，拖拽实际并不会改变绑定数据的顺序，这里需要自己做数据的顺序更改
                          let data=JSON.parse(JSON.stringify(_this.data))
                          const currRow = data[i].children.splice(oldIndex, 1)[0]
                          data[i].children.splice(newIndex, 0, currRow)
                          let dataArr=[]
                          let dataJson={}
                          data[i].children.map((item,index)=>{
                              dataJson={}
                              dataJson.id=item.id
                              dataJson.list_order=index+1
                              dataArr=[...dataArr,dataJson]
                          })
                          API.service.ORDER_LIST(dataArr).then(res=>{   })
                      }
                  });
              }
                const el2 = document.querySelector('.trBigbox')
                Sortable.create(el2, {
                    handle:".dragicon",
                    disabled: false, // 是否开启拖拽
                    ghostClass: 'sortable-ghost', //拖拽样式
                    animation: 150, // 拖拽延时，效果更好看
                    group: { // 是否开启跨表拖拽
                        pull: false,
                        put: false
                    },
                    onEnd: ({ newIndex, oldIndex }) => { // 这里主要进行数据的处理，拖拽实际并不会改变绑定数据的顺序，这里需要自己做数据的顺序更改
                        let data=JSON.parse(JSON.stringify(_this.data))
                        const currRow = data .splice(oldIndex, 1)[0]
                        data.splice(newIndex, 0, currRow)
                        let dataArr=[]
                        let dataJson={}
                        data.map((item,index)=>{
                            dataJson={}
                            dataJson.id=item.id
                            dataJson.list_order=index+1
                            dataArr=[...dataArr,dataJson]
                        })
                        API.service.ORDER_LIST(dataArr).then(res=>{this.loading = true; this.$message.success({ content:res.data.msg,duration: 2 }) ;this.getList() })
                        // this.getList()
                    }
                });
            },
            confirm(id) {

                API.service.DELE( id).then(res => {
                    this.getList()
                })
            },
            onChange(row,id) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.service.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        // this.getList()
                    }
                })
                // API.service.CHANG_STATUS([Json]).then(res => {   })
            },
            resetSeach() {
                this.loading = true
                this.seach = {  name: "",   }
                this.getList(1)
            },
            getchangId(data) {
                for (let i = 0; i < data.length; i++) {
                    data[i].show=2
                    data[i].check=false
                    if (data[i].children && data[i].children.length > 0) {
                        this.getchangId(data[i].children)
                    }
                }
                return data
            },
            getList(page,type) {
                this.data=[]
                API.service.GET_LIST({page: page || 1, ...this.seach}).then(res => {
                  res.data.data.list.map((item,index)=>{
                    if(!item.children)item.children=[]
                  })
                    this.getchangId(res.data.data)
                    this.data = this.getchangId(res.data.data.list)
                    this.changData=this.getchangId(res.data.data.list)
                    this.selectedRowKeys=[]
                    this.loading = false
                    this.checAll=false
                    if(type=='open')this.editLanguage('open','1')
                    // this.$nextTick(() => {
                    //     setTimeout(() => {
                    //         this.drag()
                    //     },500)
                    // })
                     this.data=[]
                    this.$set(this.data,res.data.data.list);
                  res.data.data.list.map((item,index)=>{
                        this.$set(this.data,index,item);
                    })
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            editLanguage(name, type) {
                if (type == '5') {
                    this.confirm(this.selectedRowKeys)
                }
                let url
                let dataArr = []
                let dataJson = {}
                this.selectedRowKeys.map((item, index) => {
                    dataJson = {}
                    dataJson.id = item;
                    dataJson[name] = type;
                    dataArr.push(dataJson)
                })
                if (name == 'open') {
                    this.data.map((item,index)=>{
                        item.show=type
                    })
                }
                if (name == 'status') {
                    // changStatus(API.service.CHANG_STATUS,dataArr).then(res => {
                    //     if (res == true) {
                    //         // this.getList()
                    //         this.getList()
                    //     }
                    // })
                    let changKey = 'updatable';
                    let hide = this.$message.loading({content:'正在修改',key:changKey} )
                    API.service.CHANG_STATUS(dataArr).then(res => {
                        if (res.data.code === 200) {
                            hide();
                            let msg=dataArr[0].status==0?"隐藏成功":"显示成功"
                            this.$message.success({ content:msg, key:changKey, duration: 2 })
                            this.getList()
                        }
                    })
                }
            },

          listOrder() {
            this.getchangId(this.data)
            // API.service.ORDER_LIST(dataArr).then(res=>{   })
            let sortLists=[]
            this.data.map((item,index)=>{
              sortLists.push({id:item.id,list_order:item.list_order})
              if(item.children){
                item.children.map((itemc)=>{
                  sortLists.push({id:itemc.id,list_order:itemc.list_order})
                })
              }
            })
            orderList(API.service.ORDER_LIST, sortLists).then(res => {
              if (res == true) {
                this.getList()
              }
            })
          },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }
    .dragicon{position: absolute;right:20px;top:15px;display: inline-block;height:20px;cursor: pointer}
    .table .th{color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
        text-align: left;
        background: #fafafa;
        border-bottom: 1px solid #e8e8e8;
        transition: background 0.3s ease;}
    .table .th div{
        padding: 16px 16px;
        overflow-wrap: break-word;
    }
    .table .tr{
        border-bottom: 1px solid #e8e8e8;
        transition: all 0.3s, border 0s;
        position: relative;

    }
    /*.table .tr:hover{background-color:#e6f7ff }*/
    .table .tr .td{
        padding: 16px 16px;
        overflow-wrap: break-word;
        position: relative;
    }
    .ant-table-row-expand-icon{float: left;margin-right:4px;position: relative;top: 2px}
    .ant-divider, .ant-divider-vertical{display: none!important;}

</style>
